<template>
  <div class="page-block">
    <bank-select-dialog
      name="bankSelect"
      :is-bank-mode="true"
      :is-shown="bankSelectDialogShown"
      @select="onBankSelected"
      @closed="bankSelectDialogShown = false"
      @cancel-clicked="bankSelectDialogShown = false" />
    <bank-select-dialog
      name="bankBranchSelect"
      :is-bank-mode="false"
      :is-shown="bankBranchSelectDialogShown"
      :bank-code="item.bank_code"
      @select="onBankBranchSelected"
      @closed="bankBranchSelectDialogShown = false"
      @cancel-clicked="bankBranchSelectDialogShown = false" />
    <header-bar>登録情報</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">
        お取引先口座 - 登録
      </h3>
    </div>
    <div class="page-block__inner">
      <alert-view
        :errors="errors"
        :bankname-faq-url="banknameFaqUrl" />
      <div class="profile-info">
        <form
          :class="{ 'form--error': errors }">
          <h3 class="form-subtitle">お取引先口座</h3>
          <div class="form-wrap form-wrap--profile u-no-margin-top">
            <div class="form-group">
              <div class="form-label">
                <label
                  class="control-label">銀行名
                </label>
                <span class="req">＊</span>
              </div>
              <div class="form-item form-item--change-btn">
                <span v-if="item.bank_name">
                  ({{ item.bank_code }}) {{ item.bank_name }}
                </span>
                <span
                  v-else
                  class="error-text">
                  未登録
                </span>
                <button
                  type="button"
                  class="c-btn c-btn--narrow"
                  @click.prevent="onSelectBankClicked">
                  銀行名を選択
                  <span class="c-btn__icon-add">
                    <span></span>
                  </span>
                </button>
                <p
                  v-if="errors['bank_name']"
                  class="error-text">
                  {{ errors['bank_name'][0] }}
                </p>
              </div>
            </div>
            <template v-if="item.bank_name">
              <div
                v-if="item.bank_name"
                class="form-group">
                <div class="form-label">
                  <label
                    class="control-label">支店名
                  </label>
                  <span class="req">＊</span>
                </div>
                <div class="form-item form-item--change-btn">
                  <span v-if="item.bank_branch_name">
                    ({{ item.bank_branch_code }}) {{ item.bank_branch_name }}
                  </span>
                  <span
                    v-else
                    class="error-text">
                    未登録
                  </span>
                  <button
                    type="button"
                    class="c-btn c-btn--narrow"
                    @click.prevent="onSelectBankBranchClicked">
                    支店名を選択
                    <span class="c-btn__icon-add">
                      <span></span>
                    </span>
                  </button>
                  <p
                    v-if="errors['bank_branch_name']"
                    class="error-text">
                    {{ errors['bank_branch_name'][0] }}
                  </p>
                </div>
              </div>
              <template
                v-if="item.bank_branch_name">
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="bank_account_type">口座種別
                    </label>
                    <span class="req">＊</span>
                  </div>
                  <div class="form-item">
                    <div class="c-select_wrap">
                      <select
                        id="bank_account_type"
                        v-model="item.bank_account_type"
                        class="form-control c-select"
                        name="language">
                        <option
                          v-for="type in bankAccountTypes"
                          :key="type.id"
                          :value="type.id">
                          {{ type.text }}
                        </option>
                      </select>
                    </div>
                    <p
                      v-if="errors['bank_account_type']"
                      class="error-text">
                      {{ errors['bank_account_type'][0] }}
                    </p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="bank_account_number">口座番号
                    </label>
                    <span class="req">＊</span>
                  </div>
                  <div class="form-item">
                    <input
                      id="bank_account_number"
                      v-model="item.bank_account_code"
                      maxlength="7"
                      class="form-control form-control--account-number"
                      type="text">
                    <span class="form-item-text--inline">7桁未満の場合は頭に0を記入してください。</span>
                    <!-- eslint-disable vue/no-v-html -->
                    <p
                      v-if="errors['bank_account_code']"
                      class="error-text"
                      v-html="errors['bank_account_code'][0]">
                    </p>
                    <!-- eslint-enable vue/no-v-html -->
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label form-label--top">
                    <label
                      class="control-label"
                      for="bank_account_name">口座名義
                    </label>
                    <span class="req">＊</span>
                  </div>
                  <div class="form-item">
                    <input
                      id="bank_account_name"
                      v-model="item.bank_account_name"
                      class="form-control"
                      type="text">
                    <div class="form-item-text form-item-text--bottom">
                      <strong>
                        <router-link
                          :to="banknameFaqUrl"
                          class="c-text-link"
                          target="_blank">銀行口座名義で使用できる文字は?</router-link>
                      </strong>
                      <br>
                      販売利益をアカウント管理者様にお支払するために必要な口座になりますので、お手元に通帳をご用意の上、お間違いないよう入力してください。
                      口座情報の不備により当社が振込をできなかった場合、銀行の組み戻し費用はアカウント管理者様の負担となります。
                    </div>
                    <!-- eslint-disable vue/no-v-html -->
                    <p
                      v-if="errors['bank_account_name']"
                      class="error-text"
                      v-html="errors['bank_account_name'][0]">
                    </p>
                    <!-- eslint-enable vue/no-v-html -->
                  </div>
                </div>
              </template>
            </template>
          </div>
          <div class="c-btn-wrap">
            <a
              href="#"
              class="c-btn"
              @click.prevent="onSaveClicked">
              内容を保存
              <span class="c-btn__icon-arrow"></span>
            </a>
            <router-link
              v-if="!isFromAccountEntry"
              :to="{ name: 'profile' }"
              class="c-btn c-btn--back c-btn--back-left">
              戻る
              <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'
import AlertView from './AlertView'
import BankSelectDialog from './BankSelectDialog'

export default {
  name: 'BankProfileEdit',
  components: {
    BankSelectDialog,
    HeaderBar,
    AlertView,
  },
  props: {
    isFromAccountEntry: {
      type: Boolean,
      default: false,
    },
    isFromAccEntry: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      item: {
        bank_name: null,
        bank_code: null,
        bank_branch_name: null,
        bank_branch_code: null,
        bank_account_type: 0,
        bank_account_code: null,
        bank_account_name: null,
      },
      branchPrefixes: [],
      errors: {},
      bankAccountTypes: [
        { id: 0, text: '普通預金' },
        { id: 1, text: '当座預金' },
      ],
      bankSelectDialogShown: false,
      bankBranchSelectDialogShown: false,
      banknameFaqUrl: '',
    }
  },
  mounted() {
    this.fetchItem()
    if (this.isBtoB) {
      this.banknameFaqUrl = '/client/faqs/108'
    } else if (this.isBtoC) {
      this.banknameFaqUrl = '/client/faqs/107'
    }
  },
  methods: {
    async fetchItem() {
      const { data } = await window.axios.get(`/api/client/users/${this.$store.state.auth.id}`)
      this.item = {
        bank_name: data.company.bank_name,
        bank_code: data.company.bank_code,
        bank_branch_name: data.company.bank_branch_name,
        bank_branch_code: data.company.bank_branch_code,
        bank_account_type: data.company.bank_account_type,
        bank_account_code: data.company.bank_account_code,
        bank_account_name: data.company.bank_account_name,
      }
    },
    async onSaveClicked() {
      window.scrollTo(0, 0)
      try {
        await window.axios.put('/api/client/banks/save', this.item)
        await this.$router.push({ name: 'profile' })
      } catch ({ response }) {
        const { errors } = response.data
        this.errors = errors
      }
    },
    onSelectBankClicked() {
      this.bankSelectDialogShown = true
    },
    onBankSelected(context) {
      const { code, name } = context
      if (this.item.bank_code !== code) {
        this.item.bank_branch_name = null
        this.item.bank_branch_code = null
      }
      this.item.bank_name = name
      this.item.bank_code = code
    },
    onSelectBankBranchClicked() {
      this.bankBranchSelectDialogShown = true
    },
    onBankBranchSelected(context) {
      const { code, name } = context
      this.item.bank_branch_name = name
      this.item.bank_branch_code = code
    },
  },
}
</script>
